module.exports = "<router-outlet></router-outlet>\n<ngx-spinner\n        bdColor=\"rgba(51,51,51,0.5)\"\n        size=\"medium\"\n        color=\"#ee0202\"\n        type=\"ball-clip-rotate-pulse\">\n    <p style=\"color: #ee0202\">Lütfen Bekleyin...</p>\n</ngx-spinner>\n"


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main